import React from 'react';
import LogoRender from './LogoRender';

export const Logo = ():JSX.Element=>{
	return <LogoRender/>;
};